import { QuestionMarkCircleIcon } from '@heroicons/react/24/solid';
import { useTranslation } from 'react-i18next';
import { getSupportSiteBaseUrl } from '@/shared/lib/support-site';
import { openExternalUrl } from '@/shared/lib/utils/url';
import { Button } from '@/shared/ui';

const SUPPORT_MANUAL_URL = getSupportSiteBaseUrl();

/**
 * サポートマニュアルボタン（グローバルナビゲーション右上）
 * クリックすると新しいタブでサポートマニュアルを開く
 */
export const SupportManualButton = () => {
  const { t } = useTranslation();
  const label = t('common.actions.manual');

  return (
    <Button variant="outline" onClick={() => openExternalUrl(SUPPORT_MANUAL_URL)}>
      <QuestionMarkCircleIcon className="size-4 text-text-muted" />
      {label}
    </Button>
  );
};
